import React from 'react'
import PixelBody from './PixelBody'
import Header from './Header'
import ProductPageFooter from './ProductPageFooter'

const PixelProject = () => {
    return (
        <>
            <Header />
            <PixelBody />
            <ProductPageFooter />
        </>
    )
}

export default PixelProject
